var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOliLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.02,201.95c-61.45,0-111.26,50.63-111.26,113.1s49.81,113.09,111.26,113.09,111.26-50.63,111.26-113.09-49.81-113.1-111.26-113.1ZM214.02,376.49c-33.38,0-60.44-27.51-60.44-61.44s27.06-61.44,60.44-61.44,60.44,27.51,60.44,61.44-27.06,61.44-60.44,61.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 528.72,
    y: 207.13,
    width: 52.13,
    height: 215.85
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "396.48 377.68 396.48 207.13 344.35 207.13 344.35 377.68 344.35 422.99 396.48 422.99 504.78 422.99 504.78 377.68 396.48 377.68"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.72,446.59v86.52H62.43V66.83h343.07c1.8-10.02,5.79-19.6,11.96-28.08,8.16-11.2,19.26-19.47,32.02-24.05H10.3v570.55h570.55v-138.65h-52.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.52,137.74c-8.83-9.12-21.99-11.53-33.1-7.12l-28.5-29.43c2.97-7.25,3.86-15.03,2.74-22.52l18.42-10.63c9.48,7.29,22.78,8.58,33.78,2.24,14.56-8.4,19.56-27.02,11.16-41.58-8.4-14.56-27.02-19.56-41.58-11.16-11,6.35-16.53,18.52-14.97,30.37l-16.44,9.48c-2.18-2.58-4.66-4.97-7.51-7.05-19.14-13.93-45.95-9.71-59.88,9.43-13.93,19.14-9.71,45.95,9.43,59.88,15.41,11.21,35.77,10.65,50.4.02l26.27,27.12c-4.76,10.97-2.78,24.19,6.06,33.31,11.7,12.08,30.97,12.39,43.05.69,12.08-11.7,12.39-30.97.69-43.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOliLogoWhite);
export default __webpack_public_path__ + "static/media/OLI-logo-white.acceaf969d53c5b465363a37ac3466d2.svg";
export { ForwardRef as ReactComponent };